/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdTeacherDataQueryResponse,
  GetApiV1PersonIdTeacherDataPathParams,
  GetApiV1PersonIdTeacherData401,
  GetApiV1PersonIdTeacherData404,
  GetApiV1PersonIdTeacherData500,
} from "../../types/personTeacherController/GetApiV1PersonIdTeacherData.ts";

function getGetApiV1PersonIdTeacherDataUrl(
  id: GetApiV1PersonIdTeacherDataPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/teacher-data` as const,
  };
  return res;
}

/**
 * @description Retorna os dados da aba Teacher (TeachingStaff + campos de Person: BusinessSector, OtherBusinessSector, AcademicInstitution). O thumbnail é gerenciado pelos endpoints /teacher-thumbnail. **(Requer Authorization para autenticação)**
 * @summary Obter dados de docente (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/teacher-data}
 */
export async function getApiV1PersonIdTeacherData(
  id: GetApiV1PersonIdTeacherDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdTeacherDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdTeacherData401
      | GetApiV1PersonIdTeacherData404
      | GetApiV1PersonIdTeacherData500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdTeacherDataUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
